import fplTokens from '@figma/fpl-tokens/css-vars';

export const maxTierAccentStyles = {
  '--color-bg-brand': fplTokens.ramp.lime400,
  '--color-bg-brand-hover': fplTokens.ramp.lime300,
  '--color-bg-brand-pressed': fplTokens.ramp.lime200,
  '--color-icon-onbrand': fplTokens.ramp.grey800,
  '--color-text-onbrand': fplTokens.ramp.grey800,
};

/** ButtonContained's MUI path uses sx; its FPL path inherits the accent variables. */
export const maxTierButtonStyles = {
  '&:not(:disabled)': {
    backgroundColor: 'var(--color-bg-brand)',
    color: 'var(--color-text-onbrand)',
    '&:hover': { backgroundColor: 'var(--color-bg-brand-hover)' },
    '&:active': { backgroundColor: 'var(--color-bg-brand-pressed)' },
  },
};

export const maxTierBadgeStyles = {
  display: 'inline-flex',
  '--color-bg-brand': 'var(--weave-pricing-promotion-background)',
  '--color-icon-onbrand': 'var(--weave-pricing-badge-text)',
  '--color-text-onbrand': 'var(--weave-pricing-badge-text)',
};

/** Bridge pricing's semantic disabled colors into the shared button components. */
export const pricingDisabledActionStyles = {
  '--color-text-ondisabled': 'var(--weave-pricing-disabled-text)',
  '--color-icon-ondisabled': 'var(--weave-pricing-disabled-icon)',
};
